export default __webpack_public_path__ + "static/B0218-4df47891bb379ba1500df8a423f56ed3.png";